import { message } from "antd";

// AntDesign Message wrapper (no holder required)
const AntDesignMessage = {
  loading(content, key = "globalMessage") {
    message.open({ key, type: "loading", content, duration: 2 });
  },
  success(content, key = "globalMessage") {
    message.open({ key, type: "success", content, duration: 2 });
  },
  error(content, key = "globalMessage") {
    message.open({ key, type: "error", content, duration: 2 });
  },
  warning(content, key = "globalMessage") {
    message.open({ key, type: "warning", content, duration: 2 });
  },
  info(content, key = "globalMessage") {
    message.open({ key, type: "info", content, duration: 2 });
  },
  destroy(key = "globalMessage") {
    message.destroy(key);
  }
};

export default AntDesignMessage;
